// https://github.com/microsoft/rushstack/issues/2780
// API extractor can't support namespace exports
// export * as keyCodes from './keyCodes';
import * as keyCodes from './keyCodes';
export { keyCodes };

export {
  AVRInput,
  AVRPower,
  Accept,
  Again,
  AllCandidates,
  Alphanumeric,
  Alt,
  AltGraph,
  AppSwitch,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Attn,
  AudioBalanceLeft,
  AudioBalanceRight,
  AudioBassBoostDown,
  AudioBassBoostToggle,
  AudioBassBoostUp,
  AudioFaderFront,
  AudioFaderRear,
  AudioSurroundModeNext,
  AudioTrebleDown,
  AudioTrebleUp,
  AudioVolumeDown,
  AudioVolumeMute,
  AudioVolumeUp,
  Backspace,
  BrightnessDown,
  BrightnessUp,
  BrowserBack,
  BrowserFavorites,
  BrowserForward,
  BrowserHome,
  BrowserRefresh,
  BrowserSearch,
  BrowserStop,
  Call,
  Camera,
  CameraFocus,
  Cancel,
  CapsLock,
  ChannelDown,
  ChannelUp,
  Clear,
  Close,
  ClosedCaptionToggle,
  CodeInput,
  ColorF0Red,
  ColorF1Green,
  ColorF2Yellow,
  ColorF3Blue,
  ColorF4Grey,
  ColorF5Brown,
  Compose,
  ContextMenu,
  Control,
  Convert,
  Copy,
  CrSel,
  Cut,
  DVR,
  Dead,
  Delete,
  Dimmer,
  DisplaySwap,
  Eisu,
  Eject,
  End,
  EndCall,
  Enter,
  EraseEof,
  Escape,
  ExSel,
  Execute,
  Exit,
  F1,
  F10,
  F11,
  F12,
  F2,
  F3,
  F4,
  F5,
  F6,
  F7,
  F8,
  F9,
  FavoriteClear0,
  FavoriteClear1,
  FavoriteClear2,
  FavoriteClear3,
  FavoriteRecall0,
  FavoriteRecall1,
  FavoriteRecall2,
  FavoriteRecall3,
  FavoriteStore0,
  FavoriteStore1,
  FavoriteStore2,
  FavoriteStore3,
  FinalMode,
  Find,
  Fn,
  FnLock,
  GoBack,
  GoHome,
  GroupFirst,
  GroupLast,
  GroupNext,
  GroupPrevious,
  Guide,
  GuideNextDay,
  GuidePreviousDay,
  HangulMode,
  HanjaMode,
  Hankaku,
  HeadsetHook,
  Help,
  Hibernate,
  Hiragana,
  HiraganaKatakana,
  Home,
  Hyper,
  Info,
  Insert,
  InstantReplay,
  JunjaMode,
  KanaMode,
  KanjiMode,
  Katakana,
  Key11,
  Key12,
  LastNumberRedial,
  LaunchApplication1,
  LaunchApplication2,
  LaunchCalendar,
  LaunchContacts,
  LaunchMail,
  LaunchMediaPlayer,
  LaunchMusicPlayer,
  LaunchPhone,
  LaunchScreenSaver,
  LaunchSpreadsheet,
  LaunchWebBrowser,
  LaunchWebCam,
  LaunchWordProcessor,
  Link,
  ListProgram,
  LiveContent,
  Lock,
  LogOff,
  MailForward,
  MailReply,
  MailSend,
  MannerMode,
  MediaApps,
  MediaAudioTrack,
  MediaClose,
  MediaFastForward,
  MediaLast,
  MediaNextTrack,
  MediaPause,
  MediaPlay,
  MediaPlayPause,
  MediaPreviousTrack,
  MediaRecord,
  MediaRewind,
  MediaSkipBackward,
  MediaSkipForward,
  MediaStepBackward,
  MediaStepForward,
  MediaStop,
  MediaTopMenu,
  MediaTrackNext,
  MediaTrackPrevious,
  Meta,
  MicrophoneToggle,
  MicrophoneVolumeDown,
  MicrophoneVolumeMute,
  MicrophoneVolumeUp,
  ModeChange,
  NavigateIn,
  NavigateNext,
  NavigateOut,
  NavigatePrevious,
  New,
  NextCandidate,
  NextFavoriteChannel,
  NextUserProfile,
  NonConvert,
  Notification,
  NumLock,
  OnDemand,
  Open,
  PageDown,
  PageUp,
  Pairing,
  Paste,
  Pause,
  PinPDown,
  PinPMove,
  PinPToggle,
  PinPUp,
  Play,
  PlaySpeedDown,
  PlaySpeedReset,
  PlaySpeedUp,
  Power,
  PowerOff,
  PreviousCandidate,
  Print,
  PrintScreen,
  Process,
  Props,
  RandomToggle,
  RcLowBattery,
  RecordSpeedNext,
  Redo,
  RfBypass,
  Romaji,
  STBInput,
  STBPower,
  Save,
  ScanChannelsToggle,
  ScreenModeNext,
  ScrollLock,
  Select,
  Settings,
  Shift,
  SingleCandidate,
  Soft1,
  Soft2,
  Soft3,
  Soft4,
  Space,
  SpeechCorrectionList,
  SpeechInputToggle,
  SpellCheck,
  SplitScreenToggle,
  Standby,
  Subtitle,
  Super,
  Symbol,
  SymbolLock,
  TV,
  TV3DMode,
  TVAntennaCable,
  TVAudioDescription,
  TVAudioDescriptionMixDown,
  TVAudioDescriptionMixUp,
  TVContentsMenu,
  TVDataService,
  TVInput,
  TVInputComponent1,
  TVInputComponent2,
  TVInputComposite1,
  TVInputComposite2,
  TVInputHDMI1,
  TVInputHDMI2,
  TVInputHDMI3,
  TVInputHDMI4,
  TVInputVGA1,
  TVMediaContext,
  TVNetwork,
  TVNumberEntry,
  TVPower,
  TVRadioService,
  TVSatellite,
  TVSatelliteBS,
  TVSatelliteCS,
  TVSatelliteToggle,
  TVTerrestrialAnalog,
  TVTerrestrialDigital,
  TVTimer,
  Tab,
  Teletext,
  Undo,
  Unidentified,
  VideoModeNext,
  VoiceDial,
  WakeUp,
  Wink,
  Zenkaku,
  ZenkakuHankaku,
  ZoomIn,
  ZoomOut,
  ZoomToggle,
} from './keys';
